export default __webpack_public_path__ + "static/media/python.4ae0ca08.png";